<template>
  <div>
    <Loader v-if="loading" />
    <table class="table" v-else>
      <thead>
        <tr class="table-search">
          <td colspan="6">
            <b-form-input
              v-model="search"
              class="search"
              @input="currentPage = 1"
              style="margin-top: 0px; margin-bottom: 15px"
              placeholder="Leita"
            />
          </td>
        </tr>
        <tr>
          <th>
            <LinkOrder title="Kennitala" :filteredList="getList" :list="list" column="kennitala" secondColumn="nafn" />
            ({{ getList.length }})
          </th>
          <th>
            <LinkOrder title="Nafn" :filteredList="getList" :list="list" column="nafn" />
          </th>
          <th>
            <LinkOrder title="Bekkur" :filteredList="getList" :list="list" column="bekkur_heiti" secondColumn="nafn" />
          </th>
          <th>
            <LinkOrder title="Árgangur" :filteredList="getList" :list="list" column="braut_heiti" secondColumn="nafn" />
          </th>
          <th>
            <LinkOrder title="Móðurmál" :filteredList="getList" :list="list" column="heiti_mals" secondColumn="nafn" />
          </th>
          <th>
            <LinkOrder title="Umsjónarkennari" :filteredList="getList" :list="list" column="umsjonarkennari" secondColumn="nafn" />
          </th>
        </tr>
      </thead>
      <tbody>
        <TableRowLoader v-if="loading" colspan="6" :center="true" />
        <TableRowEmpty v-if="!loading && this.list.length === 0" colspan="6" :center="true" />
        <tr v-for="item in getPaginatedList" :key="item.id">
          <td>{{ item.kennitala }}</td>
          <td>{{ item.nafn }}</td>
          <td>{{ item.bekkur_heiti }}</td>
          <td>{{ item.braut_heiti }}</td>
          <td>{{ item.heiti_mals }}</td>
          <td>{{ item.umsjonarkennari }}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <Pagination
      :currentPage="currentPage"
      :totalRows="getList.length"
      :perPage="perPage"
      v-if="list.length > 25"
      @change-page="changePage"
      @change-limit="changeLimit"
    />
  </div>
</template>

<script>
import statistics from '@/api/statistics';
import { mapActions } from 'vuex';

import Loader from '@/components/common/Loader.vue';
import LinkOrder from '@/components/common/LinkOrder.vue';
import TableRowLoader from '@/components/common/TableRowLoader.vue';
import TableRowEmpty from '@/components/common/TableRowEmpty.vue';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'statistics-elementary-students',
  props: ['id'],
  components: {
    Loader,
    LinkOrder,
    TableRowLoader,
    TableRowEmpty,
    Pagination,
  },
  computed: {
    getList() {
      return this.list.filter(
        x =>
          this.search.length === 0 ||
          (x.nafn || '').toUpperCase().indexOf(this.search.toUpperCase()) > -1 ||
          x.kennitala.indexOf(this.search) > -1 ||
          (x.bekkur_heiti || '').toUpperCase().indexOf(this.search.toUpperCase()) > -1 ||
          (x.braut_heiti || '').toUpperCase().indexOf(this.search.toUpperCase()) > -1 ||
          (x.heiti_mals || '').toUpperCase().indexOf(this.search.toUpperCase()) > -1 ||
          (x.umsjonarkennari || '').toUpperCase().indexOf(this.search.toUpperCase()) > -1,
      );
    },
    getPaginatedList() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = this.currentPage * this.perPage;
      return this.getList.slice(start, end);
    },
  },
  data() {
    return {
      perPage: 25,
      currentPage: 1,
      loading: false,
      list: [],
      search: '',
    };
  },
  methods: {
    async loadList() {
      try {
        this.loading = true;
        const response = await statistics.getElementaryStudents();
        this.list = response.data.items;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    changePage(page) {
      this.currentPage = page;
    },
    changeLimit(limit) {
      this.perPage = limit;
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.loadList();
  },
};
</script>

<style lang="scss"></style>
